/* Public-safe aggregation of historical PRN recruiting demand. Confidential facilities, clients, VMS IDs, rates and addresses excluded. */
const raw=[
"S|GA|Columbus|LPN|56|14|31906",
"S|NH|Woodsville|RN - ED/ER|34|14|03785",
"S|NH|Woodsville|RN - MED/SURG|31|14|03785",
"S|LA|New Orleans|RN - MED/SURG|29|14|70112",
"S|LA|Marrero|RN - L&D|27|14|70072",
"S|LA|Metairie|RN - PCU|27|14|70006",
"S|LA|New Orleans|RN - ICU|25|14|70112",
"S|LA|Marrero|RN - Neuro Stepdown (SDU)|14|14|70072",
"S|LA|Marrero|RN - MED/SURG|19|13|70072",
"S|LA|Marrero|Rad Tech|13|13|70072",
"S|PA|Lancaster|LPN|28|12|17602",
"S|PA|Lancaster|CNA|26|11|17602",
"S|NH|Woodsville|LNA|19|9|03785",
"S|LA|Marrero|RN - ED/ER|11|9|70072",
"S|MO|Joplin|RN - MED/SURG|9|8|64804",
"S|LA|New Orleans|RN - ED/ER|11|7|70127",
"S|GA|Athens|RN - MED/SURG|10|7|30606",
"S|PA|Orwigsburg|LPN|9|7|17961",
"S|MO|Columbia|RT|8|7|65201",
"S|GA|Athens|RT|7|6|30606",
"S|LA|Metairie|RN - ED/ER|7|6|70001",
"S|LA|Metairie|RN - MED/SURG|7|6|70006",
"S|NH|Woodsville|RN - BHS|6|6|03785",
"S|LA|Marrero|RN - PACU|5|5|70072",
"S|MO|Joplin|RN - Dialysis|5|5|64804",
"S|AL|Selma|RN - ICU|6|4|36701",
"S|PA|Orwigsburg|CNA|6|4|17961",
"T|DE|Milford|CNA|160|21|19963",
"T|ME|Camden|CNA|20|20|04843",
"T|PA|Quakertown|LPN|23|15|18951",
"T|ME|Kennebunk|LPN|20|14|04043",
"T|DE|Milford|LPN|26|12|19963",
"T|ME|Kennebunk|CNA|25|11|04043",
"T|ME|Skowhegan|CNA|35|9|04976",
"T|MD|Bowie|LPN|25|6|20716",
"T|MD|Waldorf|GNA|16|6|20602",
"T|MD|Bowie|GNA|11|5|20716",
"T|PA|Bridgeville|CNA|49|4|15017",
"T|PA|Gettysburg|CNA|13|4|17325",
"T|ME|Skowhegan|RN|6|4|04976",
"T|PA|Wayne|LPN|5|4|19087",
"T|PA|Gettysburg|RN|4|4|17325",
"T|ME|Kennebunk|RN|4|4|04043",
"T|MD|Waldorf|LPN|7|3|20602",
"T|NC|High Point|LPN|5|3|27262",
"T|PA|Gettysburg|LPN|5|3|17325",
"R|PA|Wayne|CNA|18|8|19087",
"R|PA|Wayne|LPN|13|5|19087",
"R|PA|Wayne|RN|13|6|19087",
"R|MD|Bowie|GNA|9|7|20716",
"R|MD|Bowie|LPN|6|4|20716",
"R|MD|Bowie|RN|6|4|20716",
"R|MD|Brooklyn Park|GNA|3|3|21225",
"O|PA|Wayne|LPN|1|1|19087",
"O|MD|Bowie|LPN|4|2|20716",
"O|MD|Bowie|GNA|2|1|20716",
"O|MD|Waldorf|GNA|1|1|20602",
"O|ME|Westbrook|LPN|78|47|04092",
"O|PA|Wayne|CNA|9|5|19087",
"O|NC|High Point|LPN|4|2|27262",
"O|MD|Brooklyn Park|LPN|2|2|21225",
"O|PA|Langhorne|CNA|1|1|19047"
];
const roleName={LPN:"Licensed Practical Nurse (LPN)",CNA:"Certified Nursing Assistant (CNA)",LNA:"Licensed Nursing Assistant (LNA)",GNA:"Geriatric Nursing Assistant (GNA)",RT:"Respiratory Therapist (RT)","Rad Tech":"Radiologic Technologist","RN":"Registered Nurse (RN)","RN - MED/SURG":"Med-Surg Registered Nurse","RN - ED/ER":"Emergency Department Registered Nurse","RN - L&D":"Labor & Delivery Registered Nurse","RN - PCU":"Progressive Care Registered Nurse","RN - ICU":"Intensive Care Registered Nurse","RN - Neuro Stepdown (SDU)":"Neuro Stepdown Registered Nurse","RN - BHS":"Behavioral Health Registered Nurse","RN - PACU":"Post-Anesthesia Care Registered Nurse","RN - Dialysis":"Dialysis Registered Nurse"};
const stateNames={GA:"Georgia",NH:"New Hampshire",LA:"Louisiana",PA:"Pennsylvania",MO:"Missouri",AL:"Alabama",DE:"Delaware",ME:"Maine",MD:"Maryland",NC:"North Carolina"};
const slug=s=>s.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");
const allSignals=raw.map((line,i)=>{
 const [feed,state,city,rawRole,count,days,zip]=line.split("|");
 const title="PRN "+(roleName[rawRole]||rawRole);
 return {id:"repeat-prn-"+String(i+1).padStart(3,"0"),slug:["prn",rawRole,city,state].map(slug).join("-"),title,city,state,
 stateName:stateNames[state]||state,category:/\b(?:RT|Rad Tech)\b/.test(rawRole)?"Allied":"Nursing",
 arrangement:"PRN / Per Diem",status:"Historical recurring shifts",verifiedOpen:false,sourceDate:feed==="O"?"2026-10-29":feed==="R"?"2026-10-22":feed==="S"?"2026-09-07":"2026-09-11",
 lastEvidenceDate:feed==="O"?"2026-10-29":feed==="R"?"2026-10-22":feed==="S"?"2026-09-07":"2026-10-04",repeatDateCount:Number(days),historicalShiftCount:Number(count),recentObserved:feed==="R"||feed==="O",
 marketZip:zip,evidence:feed==="O"?"Recently reported new PRN order notifications by specialty and city; not a guarantee of an unfilled shift":"Historical recurring PRN demand by specialty and city",isRecurringPRN:true,isNetworkOnly:false};
});
// Later October evidence replaces, rather than double-counts, overlapping historical role-city groups.
export const RECURRING_PRN_MARKETS=[...new Map(allSignals.map(m=>[m.slug,m])).values()];
export const PRN_OBSERVATION="Historical demand only; exact current shifts must be confirmed by TRITAL Care. Historical source snapshots cover Aug 25-Sep 7, 2026 and earlier order tracking covers shifts through early Oct 2026, and a further recurring-order notification audit covers Oct 29, 2026. Confirm every shift before scheduling.";
